
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import appGuideDialog from '../../components/appGuideDialog/appGuideDialog.vue'
import { getPaySuccessResult } from '../../models/activityPayResult'

export default {
    name: viewName.activityPayResult,
    inject: ['showLoading', 'hideLoading'],
    components: {
        appGuideDialog,
    },
    data () {
        return {
            order_id: '',
            order_name: '', // 活动名称
            pay_time: '', // 支付时间
            pay_money: '', // 支付金额
            car_owner_phone: '' // 车主手机号
        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {

    },
    activated () {
    },
    mounted () {
        this.order_id = this.$route.query.order_id
        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
        this.$emit('setHeader', {
            title: '交易成功',
            showHeader: true,
            showLeft: true,
        })
        this.getDatas()
    },
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
        async getDatas () {
            try {
                this.showLoading()
                const data = await getPaySuccessResult({order_id: this.order_id})
                Object.assign(this, data)
                this.hideLoading()
            } catch (err) {
                this.hideLoading()
                this.$toast(err.errmsg || err.message)
            }
        },
        showModal () {
            this.$refs.appGuideDialog.showStatus = true
        }
    },
    destroyed () {

    },
}
